import { defineMessages } from 'react-intl';
import { CheckboxIDs, InputIDs } from './types';

/**
 * Messages for label, error and placeholder for each Input field
 */
export const formMessages = {
  [InputIDs.EMAIL]: defineMessages({
    label: {
      id: 'forms.type.email.label',
      defaultMessage: 'E-Mail Adresse',
    },
    error: {
      id: 'forms.type.email.error',
      defaultMessage: 'Bitte gib deine E-Mail an',
      valid: {
        id: 'forms.error.email',
        defaultMessage: 'Bitte gib eine gültige E-Mail-Adresse an',
      },
    },
    placeholder: {
      id: 'forms.type.email.placeholder',
      defaultMessage: 'name@anbieter.de',
    },
  }),
  [InputIDs.CUSTOMERID]: defineMessages({
    label: {
      id: 'forms.type.customernumber.label',
      defaultMessage: 'Kundennummer',
    },
    error: {
      id: 'forms.type.customernumber.error',
      defaultMessage: 'Bitte gib deine Kundennummer an!',
    },
    placeholder: {
      id: 'forms.type.customernumber.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.FIRSTNAME]: defineMessages({
    label: {
      id: 'forms.type.firstname.label',
      defaultMessage: 'Vorname',
    },
    error: {
      id: 'forms.type.firstname.error',
      defaultMessage: 'Bitte gib deinen Vornamen an!',
    },
    placeholder: {
      id: 'forms.type.firstname.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.LASTNAME]: defineMessages({
    label: {
      id: 'forms.type.lastname.label',
      defaultMessage: 'Nachname',
    },
    error: {
      id: 'forms.type.lastname.error',
      defaultMessage: 'Bitte gib deinen Nachnamen an!',
    },
    placeholder: {
      id: 'forms.type.lastname.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.STREET]: defineMessages({
    label: {
      id: 'forms.type.street.label',
      defaultMessage: 'Straße',
    },
    error: {
      id: 'forms.type.street.error',
      defaultMessage: 'Bitte gib deine Straße an!',
    },
    placeholder: {
      id: 'forms.type.street.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.HOUSENUMBER]: defineMessages({
    label: {
      id: 'forms.type.housenumber.label',
      defaultMessage: 'Hausnr.',
    },
    error: {
      id: 'forms.type.housenumber.error',
      defaultMessage: 'Bitte angeben!',
    },
    placeholder: {
      id: 'forms.type.housenumber.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.POSTALCODE]: defineMessages({
    label: {
      id: 'forms.type.postalcode.label',
      defaultMessage: 'Postleitzahl',
    },
    error: {
      id: 'forms.type.postalcode.error',
      defaultMessage: 'Bitte angeben!',
    },
    placeholder: {
      id: 'forms.type.postalcode.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.CITY]: defineMessages({
    label: {
      id: 'forms.type.city.label',
      defaultMessage: 'Ort',
    },
    error: {
      id: 'forms.type.city.error',
      defaultMessage: 'Bitte gib deinen Wohnort an!',
    },
    placeholder: {
      id: 'forms.type.city.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.PHONENUMBER]: defineMessages({
    label: {
      id: 'forms.type.phone.label',
      defaultMessage: 'Telefon',
    },
    error: {
      id: 'forms.type.phone.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.phone.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.BIRTHDAY]: defineMessages({
    label: {
      id: 'forms.type.birthday.label',
      defaultMessage: 'Geburtsdatum',
    },
    error: {
      id: 'forms.type.birthday.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.birthday.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.SALUTATION]: defineMessages({
    label: {
      id: 'forms.type.salutation.label',
      defaultMessage: 'Anrede',
    },
    error: {
      id: 'forms.type.salutation.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.salutation.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.MESSAGE]: defineMessages({
    label: {
      id: 'forms.type.message.label',
      defaultMessage: 'Deine Nachricht',
    },
    error: {
      id: 'forms.type.message.error',
      defaultMessage: 'Bitte verfasse eine Nachricht!',
    },
    placeholder: {
      id: 'forms.type.message.placeholder',
      defaultMessage: 'Beschreibe bitte kurz, wie wir dir weiterhelfen können.',
    },
  }),

  [InputIDs.FREQUENCY]: defineMessages({
    label: {
      id: 'forms.type.frequency.label',
      defaultMessage: '',
    },
    error: {
      id: 'forms.type.frequency.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.frequency.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.PAUSE]: defineMessages({
    label: {
      id: 'forms.type.pause.label',
      defaultMessage: 'Dauer',
    },
    error: {
      id: 'forms.type.pause.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.pause.placeholder',
      defaultMessage: '',
    },
  }),

  [InputIDs.SUBJECT]: defineMessages({
    label: {
      id: 'forms.type.subject.label',
      defaultMessage: 'Betreff',
    },
    error: {
      id: 'forms.type.subject.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.subject.placeholder',
      defaultMessage: 'Bitte wähle einen Betreff',
    },
  }),

  [CheckboxIDs.CANCELNL]: defineMessages({
    label: {
      id: 'forms.type.cancelnl.label',
      defaultMessage: 'Ich möchte den Newsletter abbestellen.',
    },
    error: {
      id: 'forms.type.cancelnl.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.cancelnl.placeholder',
      defaultMessage: '',
    },
  }),

  [CheckboxIDs.CANCELADVERTISING]: defineMessages({
    label: {
      id: 'forms.type.canceladvertising.label',
      defaultMessage:
        'Ich widerspreche der Zusendung von Werbemitteln einschließlich der Kataloge.',
    },
    error: {
      id: 'forms.type.canceladvertising.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.canceladvertising.placeholder',
      defaultMessage: '',
    },
  }),

  [CheckboxIDs.CANCELMARKETING]: defineMessages({
    label: {
      id: 'forms.type.cancelmarketing.label',
      defaultMessage:
        'Ich widerspreche der Nutzung, Verarbeitung und Weitergabe meiner Daten zu Marketingzwecken.',
    },
    error: {
      id: 'forms.type.cancelmarketing.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.cancelmarketing.placeholder',
      defaultMessage: '',
    },
  }),

  [CheckboxIDs.TERMS]: defineMessages({
    label: {
      id: 'forms.type.terms.label',
      defaultMessage:
        'Ich akzeptiere die <aIpid>allgemeinen Versicherungsbedingungen</aIpid> und nehme das Infoblatt gemäß FernFinG zur Kenntnis. *',
    },
    error: {
      id: 'forms.type.terms.error',
      defaultMessage: '',
    },
    placeholder: {
      id: 'forms.type.terms.placeholder',
      defaultMessage: '',
    },
  }),
};

export const specialErrorMessages = defineMessages({
  noSpecCharsNoNumbers: {
    id: 'forms.error.no.special.characters.no.numbers',
    defaultMessage: 'Sonderzeichen oder Zahlen sind nicht erlaubt',
  },
  noSpecChars: {
    id: 'forms.error.no.special.characters',
    defaultMessage: 'Sonderzeichen sind nicht erlaubt',
  },
  numbersOnly: {
    id: 'forms.error.numbersonly',
    defaultMessage: 'Nur Zahlen sind erlaubt',
  },
  email: {
    id: 'forms.error.email',
    defaultMessage: 'Bitte gib eine gültige E-Mail-Adresse an',
  },
  invalidDate: {
    id: 'forms.error.invaliddate',
    defaultMessage: 'Bitte gib ein gültiges Datum an',
  },
});

export const generalFormMessages = defineMessages({
  backToShop: {
    id: 'forms.back.to.shop',
    defaultMessage: 'Zurück zum Shop',
  },
  backToStorefront: {
    id: 'forms.back.to.storefront',
    defaultMessage: 'Zurück zur Startseite',
  },
  mandatory: {
    id: 'forms.mandatory',
    defaultMessage: 'Pflichtfelder sind mit einem Stern markiert',
  },
  errorApi: {
    id: 'forms.errorApi',
    defaultMessage: 'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.',
  },
  errorApiRecipientNotFound: {
    id: 'forms.errorApiRecipientNotFound',
    defaultMessage: 'Zu dieser E-Mail gibt es keine Newsletteranmeldung.',
  },
});

export const subjectSelectMessages = defineMessages({
  account: {
    id: 'forms.type.subject.option.account',
    defaultMessage: 'Fragen zu meinem Kundenkonto',
  },
  articleError: {
    id: 'forms.type.subject.option.articleError',
    defaultMessage: 'Artikelbeanstandung',
  },
  bonus: {
    id: 'forms.type.subject.option.bonus',
    defaultMessage: 'Fragen zu meinen Prämien',
  },
  changedEmail: {
    id: 'forms.type.subject.option.changed.email',
    defaultMessage: 'E-Mail Adresse hat sich geändert',
  },
  changedData: {
    id: 'forms.type.subject.option.changed.data',
    defaultMessage: 'Meine Daten haben sich geändert',
  },
  complaint: {
    id: 'forms.type.subject.option.complaint',
    defaultMessage: 'Fragen zu Reklamationen',
  },
  complaintComment: {
    id: 'forms.type.subject.option.complaint.comment',
    defaultMessage: 'Anregungen, Lob oder Kritik',
  },
  complaintFurtherassortments: {
    id: 'forms.type.subject.option.complaint.furtherassortments',
    defaultMessage: 'Fragen zu Reklamation weitere Sortimente',
  },
  complaintHometextile: {
    id: 'forms.type.subject.option.complaint.hometextile',
    defaultMessage: 'Fragen zu Reklamation Wohntextilien',
  },
  complaintReturnsprocessing: {
    id: 'forms.type.subject.option.complaint.returnsprocessing',
    defaultMessage: 'Fragen zur Retourenabwicklung',
  },
  complaintTextileshoes: {
    id: 'forms.type.subject.option.complaint.textileshoes',
    defaultMessage: 'Fragen zu Reklamation Textil/Schuhe',
  },
  coupons: {
    id: 'forms.type.subject.option.coupons',
    defaultMessage: 'Gutscheine und Rabatte erscheinen nicht auf meiner Rechnung',
  },
  datasecurity: {
    id: 'forms.type.subject.option.datasecurity',
    defaultMessage: 'Fragen zum Datenschutz',
  },
  delivery: {
    id: 'forms.type.subject.option.delivery',
    defaultMessage: 'Information zu Lieferungen bzw. Bestellungen',
  },
  order: {
    id: 'forms.type.subject.option.order',
    defaultMessage: 'Fragen zu meiner Bestellung',
  },
  other: {
    id: 'forms.type.subject.option.other',
    defaultMessage: 'Sonstiges',
  },
  headline: {
    id: 'forms.type.subject.option.newsletter',
    defaultMessage: 'Newsletter abbestellen',
  },
  personalData: {
    id: 'forms.type.subject.option.personalData',
    defaultMessage: 'Fragen zu meinen persönlichen Daten',
  },
  praemie: {
    id: 'forms.type.subject.option.praemie',
    defaultMessage: 'Fragen zu meinen Prämien',
  },
  product: {
    id: 'forms.type.subject.option.product',
    defaultMessage: 'Fragen zu unseren Produkten',
  },
  retoure: {
    id: 'forms.type.subject.option.retoure',
    defaultMessage: 'Probleme bezüglich Retouren',
  },
  returnData: {
    id: 'forms.type.subject.option.return.data',
    defaultMessage: 'Widerruf der Datennutzung',
  },
  web: {
    id: 'forms.type.subject.option.web',
    defaultMessage: 'Fragen zum Internetauftritt',
  },
});

export const salutationSelectMessages = defineMessages({
  notSpecified: {
    id: 'forms.type.salutation.option.notSpecified',
    defaultMessage: 'keine Angabe',
  },
  female: {
    id: 'forms.type.salutation.option.female',
    defaultMessage: 'Frau',
  },
  male: {
    id: 'forms.type.salutation.option.male',
    defaultMessage: 'Herr',
  },
});
